module.exports = __webpack_public_path__ + "img/theme.d3677401.jpg";